export default __webpack_public_path__ + "static/media/newBookPage@2x.e3ed3f0c.png";